<template>
  <div class="filters__content">
    <div class="filters__content-header">
      <div class="filters__title">
        FILTER &amp; SORT
      </div>
      <button
        type="button"
        class="filters__close"
        @click="closeFiltersPanel()"
      >
        ×
      </button>
    </div>

    <div class="filters__content-body">
      <div class="filters_count">
        Showing {{ totalProducts }} Results
      </div>
      <div
        v-if="selectedFilters.length > 0"
        class="filters__refined"
      >
        <h3 class="filters__header">
          Filtered by:
          <button
            type="button"
            class="filters__refined-clear"
            @click="clearFilters()"
          >
            Clear all
          </button>
        </h3>
        <div class="filters__pills">
          <div
            v-for="(selctedF, index) in selectedFilters"
            :key="index"
            class="filters__pill"
            :class="{ hidden: index > 4 && !showMoreTags }"
          >
            <input
              type="checkbox"
              value="product_type-cardigans"
              checked=""
            >
            <a class="filters__selected">
              {{ selctedF.name }}
            </a>
            <button
              class="no-border"
              @click="deleteCurrentInput(selctedF)"
            >
              x
            </button>
          </div>
        </div>
        <div
          v-if="selectedFilters.length > 5"
          class="filter__pills__moreLess"
        >
          <a
            v-if="!showMoreTags"
            id="seeMoreTags"
            @click="filtersShowMoreTags()"
          >+ See more</a>
          <a
            v-else
            id="seeLessTags"
            @click="filtersShowMoreTags()"
          >- See less</a>
        </div>
      </div>
      <template v-if="isSearchTemplate()">
        <div
          v-for="(block, index) in getFacetMaps[1].filter"
          :key="block.on + '_' + index"
        >
          <singleBlock
            :active-panel="activePanel"
            :all-selected-filters="selectedFilters"
            :input-to-delete="inputToDelete_"
            :single-block="block"
            @blockInputChange="onBlockChange"
            @togglePanelState="handleFilterBlockState"
            @removeFilter="onRemoveFilter"
          />
        </div>
      </template>
      <template v-else>
        <div
          v-for="(block, index) in getFacetMaps[0].filter"
          :key="block.on + '_' + index"
        >
          <singleBlock
            :active-panel="activePanel"
            :all-selected-filters="selectedFilters"
            :input-to-delete="inputToDelete_"
            :single-block="block"
            @blockInputChange="onBlockChange"
            @togglePanelState="handleFilterBlockState"
            @removeFilter="onRemoveFilter"
          />
        </div>
      </template>
      <h3 class="filters__header">
        Sort By:
      </h3>
      <sortByFilterBlock @sortByOrder="onSortBy" />
    </div>
    <div class="filters__content-footer">
      <div class="filters_count">
        Showing {{ totalProducts }} Results
      </div>
      <filtersButtonBlock
        v-if="mobile"
        :selected-filters="selectedFilters"
        @sortByOrder="onSortBy"
        @viewResults="onCloseFilterPanel"
        @clearFilters="clearFilters"
      />
    </div>
  </div>
</template>
<script>
import { mergeWith, isEqual } from 'lodash-es'
const diff = require('deep-object-diff').diff
import singleBlock from './singleBlock.vue'
import sortByFilterBlock from './sortbyFilterBlock.vue'
import filtersButtonBlock from './filtersButtonBlock.vue'
import { formatLocalizedPrice } from '~/helpers/format'

import { mapState } from 'vuex'

export default {
  name: 'FilterSidebar',
  components: {
    singleBlock,
    sortByFilterBlock,
    filtersButtonBlock,
  },
  props: {
    totalProducts: {
      type: Number,
      default: 0,
    },
    filterData: Array,
    initialParams: Array,
  },
  data() {
    return {
      selectedFilters: [],
      closeFilters: false,
      inputToDelete_: {},
      facetMaps: [],
      isPriceFilterAdded: false,
      showMoreTags: false,
      activePanel: false,
      isInitialLoad: true,
    }
  },
  computed: {
    getFacetMaps() {
      return this.$store.getters.getFacetMaps
    },
    collection() {
      return this.$store.state.collection
    },
    mobile() {
      return window.innerWidth <= 768 ? true : false
    },
  },

  watch: {
    selectedFilters: {
      deep: true,
      handler: function(newValue, oldValue) {

        /**
         * When the customer directly accesses a URL with filters in, the page will:
         * - Read these filters from the URL
         * - Query Attraqt with Filters
         * - The CollectionPageContainer state will update the active filters,
         *   in turn updating this.selectedFilters in this component.
         * - This will emit an event back up to the parent, querying Attraqt again.
         * - This leads to two API calls on load
         * - If mint.flags.collection.enableRestoreScroll is enabled, this breaks
         *   scroll restoration, as it overrides the first query.
         * - This boolean ensures that the second API query on page load
         *   doesn't break scroll position on 'Back'.
         * - PLP filters need a heavy refactor.
         */
        if (this.isInitialLoad) {
          return
        }

        this.$emit('selectedFilters', this.selectedFilters)
      },
    },
  },

  mounted() {
    this.initialParamFilters()
    this.$nextTick(() => {
      this.allFacetMaps_()
    })
  },

  methods: {
    closeFiltersPanel() {
      this.$emit('viewResults')
    },

    addCurrencySymbol(priceValue) {
      return formatLocalizedPrice(priceValue * 100)
    },

    isSearchTemplate() {
      return window.location.pathname.includes('/search')
    },

    initialParamFilters() {
      const _isSearchTemplate = window.location.pathname.includes('/search')
        ? true
        : false

      if (!_isSearchTemplate && this.initialParams[0].length > 0) {
        const checkFilterData = JSON.parse(
          JSON.stringify(this.getFacetMaps[0]['filter']),
        ).map(item => {
          return item.on
        })
        const iPF = this.initialParams.map(param => {
          const splitParam = param.split('=')
          if (splitParam[0] === 'price') {
            const priceFilterSplit = decodeURIComponent(splitParam[1]).split(
              '<',
            )
            const minPrice = priceFilterSplit[0]
            const maxPrice = priceFilterSplit[2]
            const filterField = priceFilterSplit[1]
            return {
              filter_on: filterField,
              minPrice,
              maxPrice,
              value: `${minPrice}<${filterField}<${maxPrice}`,
              name: `${this.addCurrencySymbol(
                parseFloat(minPrice).toFixed(0),
              )} <
            price < ${this.addCurrencySymbol(parseFloat(maxPrice).toFixed(0))}`,
            }
          }
          return {
            filter_on: param.split('=')[0],
            value: param.split('=')[1],
          }
        })

        // Loop through iPF and if the "filter_on" value matches the "on" value in this.collection[0].facetmap[0]['filter'] then add it to this.selectedFilters.
        let myNewArray = []

        iPF.forEach(item => {
          let item_filteron = item.filter_on
          if (item.value.includes('new_in')) {
            // Strip item of all encoded characters
            const newIn = item.value.replace(/%[0-9A-F]{2}/gi, function(match) {
              return decodeURIComponent(match)
            })

            item_filteron = 'new_in'
          }

          if (item.filter_on == window.mint.services.attraqt.priceField) {
            const splitValue = decodeURIComponent(item.value).split('<')
            item_filteron = splitValue[1]
            myNewArray.push(item)
            this.isPriceFilterAdded = true
            return
          }
          const index = checkFilterData.indexOf(item_filteron)

          if (index > -1) {
            myNewArray.push(
              JSON.parse(JSON.stringify(this.getFacetMaps[0]['filter'][index])),
            )
          }
        })
        myNewArray = myNewArray.map(item => {
          if (item.filter_on) {
            return item
          }
          const filterBlockItem = item.filtersection.map(val => {
            return {
              filter_on: item['on'],
              value: val['value'].value,
              name: val['link'].name,
            }
          })

          return filterBlockItem
        })

        const selectedFiltersNew = []

        // Loop through myNewArray and for each item check its 'value' value and if it matches the 'value' value in iPF then add it to this.selectedFilters.
        myNewArray.forEach(item => {
          if (!Array.isArray(item)) {
            selectedFiltersNew.push(item)
            return
          }
          iPF.forEach(i => {
            const index = item.findIndex(ind => {
              if (ind.value.includes('new_in') && i.value.includes('new_in')) {
                return true
              }

              return i.value === ind.value
            })

            if (index > -1) {
              selectedFiltersNew.push(item[index])
            }
          })
        })

        // If any item within selectedFiltersNew array shares a 'name' value with any other item in selectedFiltersNew array then remove that item from the array.
        function getUniqueListBy(arr, key) {
          return [...new Map(arr.map(item => [item[key], item])).values()]
        }

        this.selectedFilters = getUniqueListBy(selectedFiltersNew, 'name')

        /**
         * Wrap in a timeout, as the watch:selectedFilters would often run
         * after this flag was set to false.
         */
        setTimeout(() => {
          this.isInitialLoad = false
        })
      }
    },

    handleFilterBlockState(response) {
      let activePanel = false

      if (response?.isOpen && response?.name) {
        activePanel = response.name
      }

      this.activePanel = activePanel
    },

    onBlockChange(val) {
      this.isInitialLoad = false
      if (val.filter_on != window.mint.services.attraqt.priceField) {
        if (val.checked) {
          this.selectedFilters.unshift(val)
        }
      } else {
        if (!this.isPriceFilterAdded) {
          this.selectedFilters.push(val)
          this.isPriceFilterAdded = true
        } else {
          this.updateSelectedFilters(val)
        }
      }

      if (!val.checked) {
        this.deleteCurrentInput(val)
        return
      }

      const matchingFacet = this.facetMaps.filter.find(facet => {
        return facet.on === val.filter_on
      })

      if (!matchingFacet || !matchingFacet?.facetid || !val.value) {
        return
      }

      /**
       * When a facet is enabled, track the event in Attraqt.
       */
      mint.EventBus.dispatch('attraqt:trackEvent', {
        action: 'click',
        target: {
          facet: `${matchingFacet.facetid}`,
          [matchingFacet.facetid]: val.value,
        },
        metadata: {
          locale: 'en_GB',
        },
      })
    },

    onRemoveFilter(val) {
      this.isInitialLoad = false
      const [group, value] = [...val]

      // Grab the current param
      const currentSearchParam = new URLSearchParams(window.location.search)

      // CHeck to see if a non-sort filter is applied e.g Product Type
      const initialFiltered = window.location.search
        ?.split('?filtered=[')[1]
        ?.split(']')[0]

      // Dirty Attraqt implementation so need to update string as params don't parse correctly
      const filterToRemoveMulti = `&${group}=${value}`
      const filterToRemoveSingle = `${group}=${value}`

      if (initialFiltered) {
        let filteredBy
        if (group === 'price') {
          filteredBy = initialFiltered
            .split('&')
            .filter(item => {
              const group = item.split('=')[0]
              return group !== 'price'
            })
            .join('&')
        } else {
          // Initial non sort filter exists, replace the selected type out of string
          const filterToRemoveMulti = `&${group}=${value}`
          const filterToRemoveSingle = `${group}=${value}`
          filteredBy = initialFiltered.replace(filterToRemoveMulti, '')
          filteredBy = filteredBy.replace(filterToRemoveSingle, '')
        }

        // Check if it's the first or not and update accordingly.
        if (filteredBy.substring(0, 1) == '&')
          filteredBy = filteredBy.slice(1, filteredBy.length)

        // Is a sort currently applied. Can grab this out of Params
        const sortCheck = currentSearchParam.get('fh_sort_by')

        if (filteredBy.length > 0) {
          // More than 1 filter initially.
          filteredBy = `?filtered=[${filteredBy}]`
        }

        if (sortCheck) {
          const _urlParams =
            (filteredBy.length > 0 ? filteredBy + '&' : '?') +
            'fh_sort_by=' +
            sortCheck
          window.history.pushState(
            {},
            '',
            window.location.pathname + _urlParams,
          )
        } else {
          window.history.pushState(
            {},
            '',
            window.location.pathname + filteredBy,
          )
        }

        this.deleteCurrentInput(val)
      }
    },

    onSortBy(order) {
      this.$emit('order_by', order)
    },

    onCloseFilterPanel() {
      this.$emit('viewResults')
    },

    clearFilters() {
      if (this.selectedFilters.length > 0) {
        this.selectedFilters = []
        this.isPriceFilterAdded = false
      }
    },

    deleteCurrentInput(filter) {
      let index = 0
      this.inputToDelete_ = filter
      this.$emit('filterToDelete', this.selectedFilters)

      for (let i = 0; i < this.selectedFilters.length; i++) {
        if (this.selectedFilters[i].name == filter.name) {
          if (filter.filter_on == window.mint.services.attraqt.priceField) {
            this.isPriceFilterAdded = false
            this.onRemoveFilter(['price', filter])
          }
          index = i
          this.selectedFilters.splice(index, 1)
          return
        }
      }
    },

    filtersShowMoreTags() {
      this.showMoreTags == true
        ? (this.showMoreTags = false)
        : (this.showMoreTags = true)
    },

    allFacetMaps_() {
      let newFacetMaps

      JSON.parse(JSON.stringify(this.getFacetMaps)).forEach(facetItem => {
        if (facetItem.universe === 'mintvelvet') {
          newFacetMaps = facetItem
          return facetItem
        }
      })

      JSON.parse(JSON.stringify(this.getFacetMaps)).forEach(item => {
        item
      })

      mergeWith(newFacetMaps, this.facetMaps, function(
        objectValue,
        sourceValue,
        key,
        object,
        source,
      ) {})

      const checkEqual = isEqual(
        JSON.stringify(newFacetMaps.filter, null, 2),
        JSON.stringify(this.facetMaps.filter, null, 2),
      )

      if (checkEqual) {
        return
      }

      this.facetMaps = JSON.parse(JSON.stringify(newFacetMaps))
    },

    updateSelectedFilters(filter) {
      for (let i = 0; i < this.selectedFilters.length; i++) {
        if (
          this.selectedFilters[i].filter_on ==
          window.mint.services.attraqt.priceField
        ) {
          this.selectedFilters[i] = filter
          return
        }
      }
    },
  },
}
</script>
<style scoped>
.no-border {
  border: none;
}
</style>
